import React, { useState } from "react";
import cn from "classnames";
import Icon from "../Icon";

const MenusButton = ({ item, param, setParam }) => {
  const [mouseDown, setMouseDown] = useState(false);

  const handleDown = () => {
    setMouseDown(true);
  }

  const handleUp = () => {
    setMouseDown(false);
  }

  return (
    <div className={cn("menu__item",
      { active: param === item.title.toLowerCase() },
      { down: mouseDown }
    )}
      onClick={() => param !== item.title.toLowerCase() &&
        setParam(item.title.toLowerCase())}
      onMouseDown={handleDown}
      onMouseLeave={handleUp}
      onMouseUp={handleUp}>
      <div className="menu__preview">
        <Icon.CircleDashed className="menu__stroke" />
        {item.icon}
      </div>
      <div className="menu__title">{item.title}</div>
    </div>
  )
}

export default MenusButton;